import { ReactNode } from 'react';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';

export interface DetailCardProps {
  children?: ReactNode;
  title?: ReactNode;
}

export const DetailCard = ({ title, children }: DetailCardProps) => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 3 }}>
        {title && (
          <Typography variant="h2" mb={3}>
            {title}
          </Typography>
        )}
        {children}
      </CardContent>
    </Card>
  );
};
